import { Button, Space, Typography, Flex } from "antd";
import { Tabs, Tooltip } from "@libertify/ui";
import { MetadataAsset } from "../types";
import { CanAccess } from "@refinedev/core";
import { GlobalOutlined, YahooOutlined } from "@ant-design/icons";

export type VideoMetadataAssetTabsProps = {
  assets: MetadataAsset[] | undefined;
};

export const VideoMetadataAssetTabs = ({
  assets,
}: VideoMetadataAssetTabsProps) => {
  if (!assets) return null;
  return (
    <Tabs
      size="small"
      items={assets.map((asset, index) => {
        return {
          label: String(asset.ticker),
          key: String(index),
          disabled: false,
          children: (
            <Flex vertical>
              <Typography.Text>{asset.name}</Typography.Text>
              <Flex justify="space-between">
                <Space>
                  <Typography.Text>{asset.isin}</Typography.Text>
                  <CanAccess resource="media_generation_steps" action="show">
                    <Button
                      target="_blank"
                      icon={<YahooOutlined />}
                      type="link"
                      href={`https://finance.yahoo.com/quote/${asset.ticker}`}
                    />
                  </CanAccess>
                </Space>
                <Tooltip content={asset.mic_code}>
                  <Typography.Text style={{ opacity: 0.5 }}>
                    <GlobalOutlined /> {asset.market}
                  </Typography.Text>
                </Tooltip>
              </Flex>
            </Flex>
          ),
        };
      })}
    />
  );
};
